import _ from 'lodash';

const $ = window.jQuery;

$(() => {
    const $accordions = $('.accordion');

    if (!$accordions.length) {
        return;
    }

    setMaxHeights();

    _.each($accordions, accordion => {
        const $accordion = $(accordion);
        const $tabs = $accordion.find('.accordion__tab');

        _.each($tabs, tab => {
            const $tab = $(tab);
            const $head = $tab.children('.accordion__head').first();

            $head.on('click', function() {
                const $content = $(this).next('.accordion__content');
                setMaxHeight($content);
                if (!$(this).hasClass('accordion__head--open')) {
                    $(this).addClass('accordion__head--open');
                    const maxHeight = `${$(this)
                        .next('.accordion__content')
                        .attr('data-max-height')}px`;
                    $content.css({ maxHeight });
                } else {
                    $(this).removeClass('accordion__head--open');
                    $content.css({ maxHeight: 0 });
                }
            });
        });
    });

    $(window).on(
        'resize',
        _.throttle(() => {
            setMaxHeights();
            _.each($('.accordion__head--open'), el => {
                const maxHeight = `${$(el)
                    .next('.accordion__content')
                    .attr('data-max-height')}px`;
                const $content = $(el).next('.accordion__content');
                $content.css({ maxHeight });
            });
        }, 150),
    );

    function setMaxHeights() {
        _.each($('.accordion__content'), content => {
            const $content = $(content);
            let maxHeight = $content
                .children('.accordion__content-inner')
                .first()
                .outerHeight(true);
            // $content
            //     .find(
            //         '.aam-image.aam-image--align-left,.aam-image.aam-image--align-right',
            //     )
            //     .each(function() {
            //         maxHeight += $(this).outerHeight(true);
            //     });
            $content
                .children('.accordion__content-inner')
                .css({ height: maxHeight });
            const transition = `max-height ${maxHeight *
                3.25}ms cubic-bezier(0.19, 1, 0.22, 1)`;
            $content.attr('data-max-height', maxHeight).css({ transition });
        });
    }

    function setMaxHeight($content) {
        const maxHeight = $content
            .children('.accordion__content-inner')
            .first()
            .outerHeight(true);
        const transition = `max-height ${maxHeight *
            3.25}ms cubic-bezier(0.19, 1, 0.22, 1)`;
        $content.attr('data-max-height', maxHeight).css({ transition });
    }
});
